import { apiUrl as API_BASE_URL } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import { getTeams } from './teams';

// src/services/driverReservationsApi.js
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
  }
});

export const PulseScraperAPI = {
  // Basic CRUD operations
  getAll: () => api.get('pulse/'),
  getById: (id) => api.get(`pulse/${id}/`),
  create: (data) => api.post('pulse/', data),
  update: (id, data) => api.put(`pulse/${id}/`, data),
  delete: (id) => api.delete(`pulse/${id}/`),

  // Custom endpoints
  getActive: () => api.get('pulse/active/'),
  getArchived: (searchParams) => api.get('pulse/archived/', { params: searchParams }),

  // Add more custom endpoints as needed
  getWeekDatesFromYearAndWeek: (year, week) => api.get(`pulse/scraper/get-week-dates/`, { params: { year: year, week: week } }), // Returns {startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD'}
  runScraper: (data) => api.post('pulse/scraper/run/', data), // data is {year: 2023, week: 1}

  getReport: (year, week) => api.get('pulse/scraper/report/', { params: { year: year, week: week } }), // Returns report data based on filters
  patchReport: (id, data) => api.patch(`pulse/scraper/${id}/`, data), // Patch B130 report by ID

  getPulsePeople: (filters) => api.get('pulse/people/', { params: filters }), // Returns pulse people based on filters
  getTopCustomers: (year, week) => api.get('pulse/report/top-customers/', { params: { year: year, week: week } }), // Returns top customers for the specified year and week
};

export const B130ReportAPI = {
  getEntries: (filters) => api.get(`pulse/report/`, { params: filters }), // Returns B130 entries for the specified year and week
  getKPITeams: (filters) => api.get('pulse/report/b085-people/', { params: filters }), // Returns KPI teams based on filters
  getPulseMVPs: (filters) => api.get('pulse/report/pulse-mvps/', { params: filters }), // Returns pulse MVPs based on filters
};

// Add request interceptor to include token
api.interceptors.request.use(async (config) => {
  const token = await UserProfile.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});